import React from 'react';
import { Text, View } from 'react-native';

import { Switch } from '../../base-components';
import styles from './styles';

type Props = {
  value: boolean;
  label: string;
  onTogglePress: () => void;
  optionalElement?: JSX.Element | null | undefined;
};

const PillToggle: React.FC<Props> = ({ value, label, onTogglePress, optionalElement = null }) => (
  <View style={styles.pillBody}>
    {label ? <Text style={styles.pillLabel}>{label}</Text> : null}
    {optionalElement}
    <View style={styles.toggle}>
      <Switch value={value} onPress={onTogglePress} />
    </View>
  </View>
);

export default PillToggle;
